export default __webpack_public_path__ + "static/media/bannerup.f3662a6a.jpg";